import { ModuleWithProviders, NgModule, Provider } from '../injection';

import { NOTIFICATIONS_SERVICE } from './interfaces/notifications.interface';
import { NotificationsService } from './services/notifications.service';
import { PULSE_NOTIFICATIONS_SERVICE, PulseNotificationsService } from './services/pulse-notifications.service';
import { RECENT_NOTIFICATIONS_SERVICE, RecentNotificationsService } from './services/recent-notifications.service';

@NgModule({
  exports: [],
  imports: [],
})
export class MobizCommonNotificationsModule {
  public static readonly PROVIDERS: Provider[] = [
    {
      provide: NOTIFICATIONS_SERVICE,
      useClass: NotificationsService,
    },
    {
      provide: PULSE_NOTIFICATIONS_SERVICE,
      useClass: PulseNotificationsService,
    },
    {
      provide: RECENT_NOTIFICATIONS_SERVICE,
      useClass: RecentNotificationsService,
    },
  ];

  public static forRoot(): ModuleWithProviders<MobizCommonNotificationsModule> {
    return {
      ngModule: MobizCommonNotificationsModule,
      providers: MobizCommonNotificationsModule.PROVIDERS,
    };
  }
}
